import {z} from 'zod';

/** Interpolated unescaped into a regex character class: keep `-` last and `^` off the front. */
export const PASSWORD_SPECIAL_CHARACTERS = '# ? ! @ $ % ^ & * -';

const STRONG_PASSWORD_REGEX = new RegExp(
  `^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[${PASSWORD_SPECIAL_CHARACTERS.replaceAll(' ', '')}]).{8,}$`,
);

export const PASSWORD_REQUIREMENTS = [
  'At least 8 characters long',
  'Contains uppercase and lowercase letters',
  'Contains at least one number',
  `Contains at least one special character: ${PASSWORD_SPECIAL_CHARACTERS}`,
];

/** Shared with API routers and client-side password forms. */
export const StrongPasswordSchema = z
  .string()
  .regex(
    STRONG_PASSWORD_REGEX,
    `Password must be at least 8 characters with an uppercase letter, a lowercase letter, a number, and a special character (${PASSWORD_SPECIAL_CHARACTERS}).`,
  );

/** react-hook-form `validate` adapter for StrongPasswordSchema. */
export function validateStrongPassword(value: string): true | string {
  const result = StrongPasswordSchema.safeParse(value);
  return result.success || (result.error.issues[0]?.message ?? 'Invalid password');
}
